import MUIBox from '@material-ui/core/Box';

/**
 * @deprecated not replaced in design-system
 */
export const Box = MUIBox;
